//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ResponsiveImageStrapi from '@/components/modules/ResponsiveImageStrapi'

export default {
	props: {
		data: {
			type: Object,
			default: null,
		},
	},
	data() {
		return {
			filters: ""
		}
	},
	components: {
		ResponsiveImageStrapi,
	},

	computed: {
		projects() {
			// const re = this.$store.getters.cmsdata;
			// console.log('d index: ', re.home)
			return this.$store.getters.projects
		},
		projectsCat() {
			const projects = this.$store.getters.projects;
			let categories = "";
			if (this.filters){
				categories = this.filters;
			}
			// console.log('categories: ', categories)
			if (categories !== ""){
				console.log('categories: ', categories)
				const final = Object.entries(projects).filter((project) => { 
					return project[1].categories.map( (item) => item.id).includes(categories);
				});
				return Object.fromEntries(final);
			} else {
				return this.$store.getters.projects;
			}
		},
		categories() {
			return this.$store.getters.categories
		},
		projects_recent() {
			// const recent = Object.fromEntries(Object.entries(this.posts).slice(0, 3));
			const values = Object.values(this.projectsCat)
			return values.sort((a, b) => b.Year - a.Year)
		},
	},
	async asyncData({
		params,
		error,
		store
	}) {
		// console.log("async page _slug: ", params.slug);
		try {
			await store.dispatch('getProjectsAll')
		} catch (e) {
			error({
				statusCode: e.statusCode,
				message: e.message,
			})
		}
	},
	methods: {
		isIncategory(cats) {
			const categories = this.getArray(this.data.categories);
			const projectcat = this.getArray(cats);
			return categories.some(value => projectcat.includes(value))
		},
		filterIncategory(cat) {
			// console.log("onfilter: ", cat)
			this.filters = cat;
			this.$router.push({ query: { category: cat} });
		},
		getArray(array) {
			return array.map( (item) => item.id);
		},
	},
	mounted() {
		const cat = this.$router.currentRoute.query.category;
		if (cat) {
			this.filters = parseInt(cat);
		}
	},
	watch: {
		$route(to, from) {
			const cat = to.query.category;
			if (cat) {
				this.filters = parseInt(cat);
			}
		}
	}
}

